/* @preserve
   WeatherNet Map
   Javascript Library for weatherUSA slippy (web/interactive) weather maps
   (c) 2012-2019 weatherUSA, LLC
*/

// Core-JS polyfill support
import "core-js/actual";
// Core
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import _pull from 'lodash/pull';
// Map
import L from 'leaflet';
// import moment from 'moment'; // FIXME huge;
// URL parsing
import url from 'url';
import qs from 'qs';
// Leaflet plug-ins (CORE MAP)
import './leaflet-tilelayer-wmts-src.js';
import 'leaflet-polylinedecorator';
import 'leaflet-providers';
import 'leaflet-timedimension';

// import './type.css';
import '../node_modules/leaflet/dist/leaflet.css';
import './css/weatherNetMap_core.css';

/*
TEST BABEL

var time = moment().startOf('day').fromNow();
console.log("Hello from JavaScript!");
console.log(`It's now ${time} secs from midnight`);

class BetterArray {
  constructor(arr) {
    this.arr = arr;
  }
  has(item) {
    return this.arr.includes(item);
  }
}

const myArray = new BetterArray([1, 2, 3]);

console.log(myArray.has(2)); // true
console.log(myArray.has(4)); // false
*/

export default class weatherNetMap {

	constructor(id, options) {
		var defaultOptions = {
			mapStartCenter: L.latLng(39.20, -109.518), // nice position for fullscreen map of the US
			mapStartZoom: 4,
			refreshWait: 300000,
			panWait: 600,
			infoBoxId: null
		};
		
		this.el = id;
		this.options = defaultOptions;
		L.Util.setOptions(this, options); // merge constructor options with this.options (defaults)
		
		this.is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
		this.is_ie = $('html').hasClass('ie');
		this.mapControls = {};
		this.layers = {}; // type L.Layer
		this.layerManagers = {}; // type AbstractLayerManager
		this.auxFeeds = {};
		this.auxRequestTasks = [];
		this.mapLastPosPx;
		this.loadingStack = [];
		this.loadingListeners = {}; // UI listeners for loading change events (e.g. spinner)
		this.autoUpdateListeners = {};
		this.mapMoveListeners = {};
		this.gpsTracked = false;
		this.Plugins = {};
		this.activeTimers = {};
		this.clickResponderCache = {};
		this.clickResponderCacheIdx = [];
		this.popup = null;
		this.hookListeners = {};

		// Compute required options
		if(this.options.mobileDevice === undefined) this.options.mobileDevice = L.Browser.mobile;
		this.options.smallScreen = window.matchMedia("(max-width: 760px)").matches;

		// Hack to allow this L to refer to plugins not using import() syntax
		this.L = window['L'];
	}

	mapInit() {
		// Hack to allow this L to refer to plugins not using import() syntax
		const L = window['L'];

		// Instantiate map
		this.setLoadingMonitor('mapInit', true);
		const _self = this;
		this.map = L.map(this.el, {
			center: this.options.mapStartCenter,
			zoom: this.options.mapStartZoom,
			attributionControl: false,
			markerZoomAnimation: false
		});
		
		var attrib = L.control.attribution({prefix: false});
		attrib.addTo(this.map);
		
		// Create Panes
		this.map.createPane('labels');
		this.map.getPane('labels').style.zIndex = 420;
		this.map.getPane('labels').style.pointerEvents = 'none';
		this.map.createPane('overlayOther');
		this.map.getPane('overlayOther').style.zIndex = 620;
		
		// Create default layers
		
		var defaultLayer = L.tileLayer.provider('Esri.WorldImagery', {
			attribution: 'Tiles &copy; Esri',
			className: 'tile-container-satellite'
		});
		this.map.addLayer(defaultLayer);
		var baseLayers = {
			"Satellite": defaultLayer,
		};
		
		this.layerManagers.labelsOverlay = new L.TileLayer('https://tiles-{s}.gis.weatherusa.net/overlay{r}/{z}/{x}/{y}.png', {
			subdomains: '1234',
			zIndex: 1004,
			attribution: 'Labels © weatherUSA, Map data © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
			pane: 'labels',
			className: 'tile-container-labels'
		});
		
		// Turn on city labels by default for satellite base layer
		this.map.addLayer(this.layerManagers.labelsOverlay);
		
		// Setup map view change events
		this.mapLastPosPx = this.map.getPixelBounds().min;
		this.mapLastPosPx.x = -10;
		this.mapLastPosPx.y = -10;
		this.map.on('moveend zoomend', this.updateMapOnMove, this);

		this.setLoadingMonitor('mapInit', false);
	}
	
	launchFullScreen(el) {
		if(el.requestFullScreen) {
			el.requestFullScreen();
		} else if(el.mozRequestFullScreen) {
			el.mozRequestFullScreen();
		} else if(el.webkitRequestFullScreen) {
			el.webkitRequestFullScreen();
		}
	}

	// FIXME broken
	geocodeLocation(field, zoom) {
		this.setLoadingMonitor('geocode', true);
		if(this.requestTasks.jsonRequestGeocode == undefined) this.requestTasks.jsonRequestGeocode = new Request.JSON({
			url: '/api/feed',
			timeout: 10,
			link: 'cancel',
			onSuccess: function(obj) {
				if(typeof obj === 'object' && 'place' in obj && obj.place[0]) {
					if(zoom) {
						var zFinal = zoom;
					} else {
						var zFinal = 11;
					}
					this.updateLocation(obj.place[0].lat, obj.place[0].lon, zFinal);
				}
				this.setLoadingMonitor('geocode', false);
			}.bind(this),
			onError: function(text, error) {
				// console.log(error);
				this.setLoadingMonitor('geocode', false);
			}.bind(this)
		});
		this.requestTasks.jsonRequestGeocode.get({'type': 'place', 'q': field});
	}

	updateLocation(lat, lon, zoom) {
		if(zoom) {
			var zFinal = zoom;
		} else {
			var zFinal = 12;
		}
		this.map.setView([lat, lon], zFinal);
	}

	geolocated(pos) {
		this.updateLocation(pos.coords.latitude, pos.coords.longitude, 12);
		var myPosIcon = new L.DivIcon({
			iconSize: [20, 20],
			className: 'icon-mylocation pulsate',
			html: '<div></div><strong></strong>'
		});
		L.marker([pos.coords.latitude, pos.coords.longitude], {icon: myPosIcon}).addTo(this.map);
	}
	
	geolocationError(e) {
		switch(e.code)
		{
			case e.PERMISSION_DENIED:
				return false;
				break;
			case e.POSITION_UNAVAILABLE:
				msg = "Location information is not available. Please check your GPS settings."
				break;
			case e.TIMEOUT:
				msg = "Location information temporarily unavailable."
				break;
			case e.UNKNOWN_ERROR:
				msg = "An unknown error occurred while getting location."
				break;
		}
		alert(msg);
	}

	setLoadingMonitor(id, on) {
		if(on === false) {
			_pull(this.loadingStack, id);
		} else {
			this.loadingStack.push(id);
		}
		Object.keys(this.loadingListeners).forEach((k) => {
			this.loadingListeners[k](this.loadingStack);
		});
	}
	
	updateMapOnMove() {
		if(!this.activeTimers.hasOwnProperty('mapMoveRefresh')) this.activeTimers.mapMoveRefresh = debounce(this.updateLayersOnViewChange.bind(this), this.options.panWait);
		this.activeTimers.mapMoveRefresh();
	}
	
	updateLayersOnViewChange() {
		if(Math.abs(this.mapLastPosPx.x - this.map.getPixelBounds().min.x) > 3 || Math.abs(this.mapLastPosPx.y - this.map.getPixelBounds().min.y) > 3)
		{
			this.mapLastPosPx = this.map.getPixelBounds().min;
			Object.keys(this.mapMoveListeners).forEach(function(k) {
				var fn = this.mapMoveListeners[k];
				if(typeof fn === 'string') {
					// name of active layer
					this.layerManagers[fn].refreshLayer();
				} else if(typeof fn === 'function') {
					// ref to function callee
					return fn();
				}
			}, this);
		}
	}
	
	updateAllLayersPeriodic() {
		if(!this.activeTimers.hasOwnProperty('globalRefresh')) this.activeTimers.globalRefresh = setInterval(this.updateAllLayers.bind(this), this.options.refreshWait);
	}
	
	cancelUpdatePeriodic() {
		if(this.activeTimers.hasOwnProperty('globalRefresh')) clearInterval(this.activeTimers.globalRefresh);
		delete(this.activeTimers.globalRefresh);
	}
	
	updateAllLayers() {
		Object.keys(this.autoUpdateListeners).forEach(function(k) {
			var fn = this.autoUpdateListeners[k];
			if(typeof fn === 'string') {
				// name of active layer
				this.layerManagers[fn].refreshLayer();
			} else if(typeof fn === 'function') {
				// ref to function callee
				return fn();
			}
		}, this);
	}

	// from = layer.id, e = event, content = popup HTML content
	// e.singleton = stop event if layer can have overlapping triggers
	// e.
	forwardedClickHandler(from, e, content) {
		if(e._stopped) return;

		var layerManager = this.layerManagers[from];

		// Layer with multiple overlaying polygons or markers should be stopped early
		if(e.singleton === true && this.clickResponderCache[from]) return false;

		if(content) {
			if(!this.clickResponderCache[from]) {
				this.clickResponderCache[from] = {
					"tablabel": (layerManager.popupName || layerManager.name || ""),
					"contents": []
				};
				this.clickResponderCacheIdx.push(from);
			}
			if(!e.coalesce || (e.coalesce && this.clickResponderCache[from].contents.length === 0)) {
				this.clickResponderCache[from].contents.push(content);
			}
		}

		// Don't propogate simulated clicks, master click will handle cascading thru layers
		if(e._simulatedEvent) return true;

		var target;
		if(e.layer) {
			target = (e.layer._icon || e.layer._path || e.target);
		} else if(e.target) {
			target = (e.target._icon || e.target._path || e.target);
		}
		
		var removed = [];

		removed.push({node: target, pointerEvents: target.style.pointerEvents});
		target.style.pointerEvents = 'none';

		while(target) {
			target = document.elementFromPoint(e.clientX || e.originalEvent.clientX, e.clientX || e.originalEvent.clientY);

			if(!target || !target._leaflet_id || target === this.map._container) break;

			let eventedTarget = this.map._targets[target._leaflet_id];
			if(!eventedTarget) break;
			let stopped = !eventedTarget.fire('click', {'_simulatedEvent': true, latlng: e.latlng}, true);
			if(stopped) break;

			removed.push({node: target, pointerEvents: target.style.pointerEvents});
			target.style.pointerEvents = 'none';
		}

		for(let rem of removed) {
			rem.node.style.pointerEvents = rem.pointerEvents;
		}

		var popupTabs = '<ul class="nav nav-tabs" role="tablist">';
		var popupTabContent = '<div class="tab-content">';
		// console.log(this.clickResponderCache);
		var shown = false;
		for(let layerId of this.clickResponderCacheIdx) {
			let tablabel = this.clickResponderCache[layerId].tablabel;
			let contents = this.clickResponderCache[layerId].contents;
			popupTabs = popupTabs + '<li class="nav-item"><a class="nav-link' + (!shown ? ' active' : '') + '" href="#popup_tab_' + layerId + '" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true">' + tablabel + '</a></li>';
			popupTabContent = popupTabContent + '<div class="tab-pane' + (!shown ? ' show active' : '') + '" id="popup_tab_' + layerId + '" role="tabpanel">';
			for(let c of contents) {
				popupTabContent = popupTabContent + '<div class="content-section">' + c + '</div>';
			}
			popupTabContent = popupTabContent + '</div>';
			shown = true;
		}
		popupTabs = popupTabs + '</ul>';
		popupTabContent = popupTabContent + '</div>';
		var popupContent = '<div id="popup_silly_container">' + popupTabs + popupTabContent + '</div>';
		// Parse pop-up content so we can call popup.update() later without rebuilding DOM
		var $el = $(popupContent);
		$el.find('.nav-link').on('shown.bs.tab', e => {
			this.popup.update();
		});
		var el = $el.get(0);

		if(this.options.infoBoxId && this.options.smallScreen) {
			document.getElementById(this.options.infoBoxId).innerHTML = popupContent;
			document.getElementById(this.options.infoBoxId + '_wrapper').classList.add('open');
		} else {
			if(this.popup) {
				// Clear old popup first to avoid DOM issue
				let oldPopup = this.popup;
				this.map.closePopup(oldPopup);
			}
			var newPopup = this.L.popup({autoPanPadding: this.L.point(32,10), minWidth: 320, maxWidth: 555, maxHeight: 360})
			.setLatLng(e.latlng)
			.setContent(el);
			this.map.openPopup(newPopup);
			this.popup = newPopup;
		}

		this.clickResponderCache = {};
		this.clickResponderCacheIdx = [];

		return true;
	}

	/* Hooking */
	addHook(hid, id, cb) {
		if(this.hookListeners[hid] === undefined) this.hookListeners[hid] = {};
		this.hookListeners[hid][id] = cb;
	}

	removeHook(hid, id) {
		if(this.hookListeners[hid] && this.hookListeners[hid][id]) delete this.hookListeners[hid][id];
	}

	doHook(hid, data) {
		if(hid in this.hookListeners) {
			Object.keys(this.hookListeners[hid]).forEach((k) => {
				this.hookListeners[hid][k](data);
			});
		}
	}
	
	
}

window.weatherNetMap = weatherNetMap;

